import { useState } from 'react';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import EcomEngineAPI from 'api/ecom_engine_api';
import ConfirmPasswordField from 'components/formik/confirm_password_field';

export default function SetPassword() {
  const [submissionMessage, setSubmissionMessage] = useState('');
  const [submissionClass, setSubmissionClass] = useState('alert-info');

  const onSubmit = ({ newPassword }, { setSubmitting, isSubmitting }) => {
    if (isSubmitting) {
      return;
    }
    setSubmitting(true);
    setSubmissionMessage(null);
    setSubmissionClass('alert-info');

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const token = urlParams.get('token');

    EcomEngineAPI.account
      .setPassword({
        password: newPassword,
        token,
      })
      .then((result) => {
        setSubmitting(false);

        if (result.message) {
          setSubmissionMessage(result.message);
          setSubmissionClass('alert-danger');
        }

        if (result.success) {
          setSubmissionMessage(result.success);
        }
      });
  };

  const formSchema = Yup.object().shape({
    newPassword: Yup.string()
      .required('Password is required')
      .matches(/^.{10,}$/, 'Must contain at least 10 characters'),
    confirmNewPassword: Yup.string()
      .required('Passwords must match')
      .oneOf([Yup.ref('newPassword'), null], 'Passwords must match'),
  });

  return (
    <Formik
      initialValues={{
        newPassword: '',
        confirmNewPassword: '',
      }}
      validationSchema={formSchema}
      onSubmit={onSubmit}
    >
      {({ isSubmitting }) => (
        <div className="row">
          <div className="col-12 col-sm-8 col-lg-5 mx-auto">
            <div className="p-5 my-md-5 bg-white border">
              <h2 className="mb-3">Set a new password</h2>
              {submissionMessage && (
                <div
                  className={`alert ${submissionClass} alert-dismissible fade show`}
                >
                  {submissionMessage}
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setSubmissionMessage(null)}
                  />
                </div>
              )}

              <Form className="needs-validation set-password__form">
                <ConfirmPasswordField
                  passwordName="newPassword"
                  confirmPasswordName="confirmNewPassword"
                />
                <div>
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="btn btn-primary mt-4"
                  >
                    {isSubmitting ? (
                      <>
                        <i className="fas fa-spinner-third animation-momentum-spin me-2" />
                        Updating password
                      </>
                    ) : (
                      'Set new password'
                    )}
                  </button>
                </div>
              </Form>
            </div>
          </div>
        </div>
      )}
    </Formik>
  );
}
